/*@ngInject*/
module.exports = function($rootScope, $uibModal, componentsService, $sce, classifiersService) {

	return {
		scope: {
			componentId: '@'
		},
		bindToController: true,
		controllerAs: 'vm',
		controller: function() {
			let vm = this;
			vm.questionIcons = [];
			vm.imageModalOpen = false;

			vm.$onInit = function(){
				componentsService.getComponent(vm.componentId).then((res) => {
					vm.component = res.data;

					const icons = [];
					angular.forEach(vm.component.surveys, (survey) => {
						angular.forEach(survey.questions, (question) => {
							angular.forEach(question.possibleAnswers, (possibleAnswer) => {
								if (possibleAnswer.selected && possibleAnswer.icon_path) {
									icons.push(possibleAnswer.icon_path);
									vm.questionIcons.push({qid: question.id, icon_path: possibleAnswer.icon_path});
								}
							});
						});
					});

					classifiersService.getIconsByIconPathAndLanguage(icons).then((response) => {
						angular.forEach(vm.questionIcons, (qIcon) => {
							qIcon.name = _.find(response.data, (icon) => icon.icon_path === qIcon.icon_path).name;
						});
					});
				});
			};

			vm.trustedHtml = (text) => {
				return $sce.trustAsHtml(text);
			};

			vm.filterWithAnswer = (question) => {
				return question.has_answer && Number(question.is_active) === 1;
			};

			vm.openImage = (imageFile, refId) => {
				vm.imageId = imageFile.id;
				vm.imageName = imageFile.fileName;
				vm.imageReferenceId = refId;
				vm.imageModalOpen = true;
			};
		},

		template: require('./object-component-view.html')
	};
};



/** WEBPACK FOOTER **
 ** ./app/shared/directives/object-component-view.directive.js
 **/